<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="side-menu"
        transform="translate(-32, -250.4799)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <g
          id="self_improvement_FILL0_wght400_GRAD0_opsz48"
          transform="translate(32, 250.4799)"
        >
          <path
            id="Shape"
            d="M3.13333333,16 C2.74814815,16 2.42962963,15.8583333 2.17777778,15.575 C1.92592593,15.2916667 1.8,14.9333333 1.8,14.5 C1.8,14.2 1.86666667,13.9125 2,13.6375 C2.13333333,13.3625 2.32592593,13.1666667 2.57777778,13.05 L6.4,11.35 L6.4,7.9 C5.42222222,9.25 4.42962963,10.2666667 3.42222222,10.95 C2.41481481,11.6333333 1.27407407,11.975 0,11.975 L0,10.475 C1.00740741,10.475 1.92592593,10.2125 2.75555556,9.6875 C3.58518519,9.1625 4.33333333,8.425 5,7.475 L6.28888889,5.85 C6.43703704,5.65 6.61111111,5.48333333 6.81111111,5.35 C7.01111111,5.21666667 7.22962963,5.15 7.46666667,5.15 L8.53333333,5.15 C8.77037037,5.15 8.99259259,5.21666667 9.2,5.35 C9.40740741,5.48333333 9.58518519,5.65 9.73333333,5.85 L11.0222222,7.475 C11.7333333,8.39166667 12.4888889,9.12083333 13.2888889,9.6625 C14.0888889,10.2041667 14.9925926,10.475 16,10.475 L16,11.975 C14.7407407,11.975 13.6037037,11.6333333 12.5888889,10.95 C11.5740741,10.2666667 10.5777778,9.25 9.6,7.9 L9.6,11.35 L13.4222222,13.05 C13.6740741,13.1666667 13.8666667,13.3625 14,13.6375 C14.1333333,13.9125 14.2,14.2 14.2,14.5 C14.2,14.9333333 14.0740741,15.2916667 13.8222222,15.575 C13.5703704,15.8583333 13.2518519,16 12.8666667,16 L6.13333333,16 L6.13333333,15.725 C6.13333333,15.2916667 6.25185185,14.9416667 6.48888889,14.675 C6.72592593,14.4083333 7.03703704,14.275 7.42222222,14.275 L10.3777778,14.275 C10.4962963,14.275 10.6,14.225 10.6888889,14.125 C10.7777778,14.025 10.8222222,13.9083333 10.8222222,13.775 C10.8222222,13.6416667 10.7777778,13.525 10.6888889,13.425 C10.6,13.325 10.4962963,13.275 10.3777778,13.275 L7.42222222,13.275 C6.77037037,13.275 6.25185185,13.5 5.86666667,13.95 C5.48148148,14.4 5.28888889,14.9916667 5.28888889,15.725 L5.28888889,16 L3.13333333,16 Z M8,3.65 C7.55555556,3.65 7.17407407,3.47083333 6.85555556,3.1125 C6.53703704,2.75416667 6.37777778,2.325 6.37777778,1.825 C6.37777778,1.325 6.53703704,0.895833333 6.85555556,0.5375 C7.17407407,0.179166667 7.55555556,0 8,0 C8.44444444,0 8.82592593,0.179166667 9.14444444,0.5375 C9.46296296,0.895833333 9.62222222,1.325 9.62222222,1.825 C9.62222222,2.325 9.46296296,2.75416667 9.14444444,3.1125 C8.82592593,3.47083333 8.44444444,3.65 8,3.65 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
